/* eslint-disable max-len */
import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { ExternalLinkIcon, SendIcon } from "../../../../components/Icons";
import SupportModalHeader from "../../../../components/SupportModalHeader/SupportModalHeader";
import { COPY, SUPPORT_CENTER_URL } from "../constants";
import { openExternalLink } from "../../../../utils";
import { usePetStore } from "../../../../hooks/redux-hooks/pet-store/pet-store.service";
import SupportActionButton from "../../../../components/SupportActionButton/SupportActionButton";
import { userActivityLogger } from "../../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../../config/mixPanelEvents";

interface LandingStepProps {
  onSubmitTicket: () => void;
}

const LandingStep = ({ onSubmitTicket }: LandingStepProps) => {
  const { petList } = usePetStore();
  const hasPets = petList && petList.length > 0;

  const handleExploreSupportCenter = () => {
    userActivityLogger(MIXPANEL_EVENTS.CUSTOMER_SUPPORT_EXPLORE_SUPPORT_CENTER, {});
    openExternalLink(SUPPORT_CENTER_URL);
  };

  const handleSubmitTicket = () => {
    userActivityLogger(MIXPANEL_EVENTS.CUSTOMER_SUPPORT_SUBMIT_TICKET_INITIATE, {});
    onSubmitTicket();
  };

  return (
    <Box className={`flex flex-col items-center w-full flex-1 ${hasPets ? "justify-between" : "justify-center"}`}>
      <Box className="flex flex-col items-center w-full">
        <SupportModalHeader
          heading={COPY.LANDING.HEADING}
          description={COPY.LANDING.DESCRIPTION}
          whiteSpacePreLine
        />
        <Button
          variant="contained"
          startIcon={<ExternalLinkIcon width={24} height={24} color="currentColor" />}
          onClick={handleExploreSupportCenter}
          sx={{
            "mt": 4,
            "backgroundColor": "violet.lighter",
            "color": "black.main",
            "borderRadius": "100px",
            "height": "40px",
            "px": 4,
            "fontSize": "14px",
            "fontWeight": 500,
            "textTransform": "none",
            "boxShadow": "none",
            "&:hover": {
              backgroundColor: "taupe.dark",
              color: "black.main",
              boxShadow: "none",
            },
          }}
        >
          {COPY.LANDING.EXPLORE_BUTTON}
        </Button>
      </Box>
      {hasPets && (
        <>
          <Box className="w-full h-px bg-gray-4 my-8" />
          <Box>
            <Box className="flex gap-1 flex-col items-center text-center px-6 mb-6 w-full">
              <Typography
                className="grenette-pro"
                sx={{ fontSize: "24px", lineHeight: "28px", fontWeight: 600 }}
              >
                {COPY.LANDING.SECTION_HEADING}
              </Typography>
              <Typography sx={{ fontSize: "14px", lineHeight: "20px", color: "black.main" }}>
                {COPY.LANDING.SECTION_DESCRIPTION}
              </Typography>
            </Box>
            <Box className="w-full pt-6">
              <SupportActionButton
                variant="contained"
                color="primary"
                fullWidth
                startIcon={<SendIcon width={24} height={24} color="currentColor" />}
                onClick={handleSubmitTicket}
              >
                {COPY.LANDING.SUBMIT_BUTTON}
              </SupportActionButton>
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};

export default LandingStep;
